import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import greenDesign from '../Images/green-design.svg'

const Youtube = ({ showAll = false }) => {
  const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const gridVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 40,
    scale: 0.97,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const [videos, setVideos] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState("");

 const displayedVideos = showAll
    ? videos
    : videos.slice(0, 3);

useEffect(() => {
  const fetchVideos = async () => {
    try {
      const response = await fetch(
        "/.netlify/functions/youtube-videos"
      );

      if (!response.ok) {
        throw new Error("Failed to fetch YouTube videos");
      }

      const data = await response.json();

      setVideos(data.videos || []);
    } catch (error) {
      console.error("YouTube videos error:", error);
      setError("Unable to load videos.");
    } finally {
      setLoading(false);
    }
  };

  fetchVideos();
}, []);

  return (
    <section className="utube-section">
           <img
    src={greenDesign}
    alt="Holistic Wellness Through Youtube Video  | Dr. Jigar Gor's Ayurveda"
    className="insta-design insta-design-top"
  />

  {/* BOTTOM RIGHT DESIGN */}
  <img
    src={greenDesign}
    alt="Holistic Wellness Through Youtube Video  | Dr. Jigar Gor's Ayurveda"
    className="insta-design insta-design-bottom"
  />
      <div className="container">

       <motion.p className="section-subheading" 
       initial="hidden" 
       whileInView="visible"
        viewport={{ once: true, amount: 0.2, }} 
        variants={fadeUp} > 
        Watch. Learn. Heal. </motion.p> 

        <motion.h2 className="section-heading" 
        initial="hidden" 
        whileInView="visible" 
        viewport={{ once: true, amount: 0.2, }} 
        variants={fadeUp} > Holistic Wellness Through Youtube Video 
        </motion.h2>
        
{loading && (
  <p className="youtube-loading">
    Loading latest videos...
  </p>
)}

{error && (
  <p className="youtube-error">
    {error}
  </p>
)}

{!loading && !error && displayedVideos.length > 0 && (
  <motion.div
    className="utube-grid"
    variants={gridVariant}
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.15,
    }}
  >
    {displayedVideos.map((video) => (
      <motion.div
        className="youtube-card"
        key={video.videoId}
        variants={cardVariant}
        whileHover={{ y: -6 }}
        transition={{ duration: 0.4 }}
      >
        <a
          href={`https://www.youtube.com/watch?v=${video.videoId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={video.thumbnail}
            alt={`${video.title} | Dr. Jigar Gor's Ayurveda`}
            loading="lazy"
          />

          <span className="youtube-play">
            ▶
          </span>
        </a>
      </motion.div>
    ))}
  </motion.div>
)}

{!loading && !error && displayedVideos.length === 0 && (
  <p className="youtube-error">
    No videos available.
  </p>
)}

        <motion.a
          href="https://www.youtube.com/@dr.jigargor.ayurveda"
          target="_blank"
          rel="noopener noreferrer"
          className="nav-btn"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.4 }}
          whileHover={{ scale: 1.04 }}
        >
          Check our Youtube
        </motion.a>

      </div>
    </section>
  );
};

export default Youtube;